import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const SimpleSuccessPopup = ({ open, children }) => {
  const navi = useNavigate()

  useEffect(() => {
    if (open) {
      document.querySelector('.application_sheet').scrollTop = 0
    }
  }, [open])
  return (
    <div className="SuccessPopup SuccessPopup--simple">
      <div className={open ? 'open success_popup notice_popup' : 'success_popup notice_popup'}>
        <div className="logo_brg"></div>
        <p>
          {children}
          <span
            className="logo_success"
            style={{
              marginTop: '56px',
              display: 'block'
            }}></span>
        </p>

        <div>
          <button type="button" className="btn_default" onClick={() => navi('/')}>
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export { SimpleSuccessPopup }

